import { states } from 'merica';
import moment from 'moment';
import React, {
	useEffect, useReducer,useRef, useState
} from 'react';
import {
	Element as ScrollElement, scroller
} from 'react-scroll';

import {
	BirthdayWrapper,
	ButtonWrapper,
	ChosenName,
	ChosenNameCheckbox,
	ChosenNameContainer,
	FirstNameContainer,
	HeaderWrapper,
	InfoWrapper,
	LastNameContainer,
	LatisseTermsWrapper,
	PageContent,
	PersonalInfoWrapper,
	PhotoContainer,
	ReferralSourceWrapper,
	SubHeader,
	TermsWrapper,
	TextArea,
	UnderAgeWrapper,
	Wrapper,
} from './styles';

const reducer = (prevState, newState) => (
	{
		...prevState,
		...newState,
	}
);

const App = props => {
	const [submitDisabled, setSubmitDisabled] = useState(true);
	const [state, setState] = useReducer(reducer,
		{
			stateIsSync: false,
			residency: '',
			chosen_name: '',
			showChosenName: false,
			'birthday.day': '',
			'birthday.month': '',
			'birthday.year': '',
			underAge: false,
			latisse: props.cart.consultation.conditions.includes('LASH'),
		});

	useEffect(() => {
		validateForm();
	},
	[state])

	// Refs to linking to birthday inputs
	const day = useRef();
	const month = useRef();
	const year = useRef();

	const validateNameAndBirthday = () => {
		if (!(day.current.value.length && month.current.value.length && year.current.value.length === 4)) {
			return false;
		}
		if (!(state.firstname && state.firstname !== '' && state.lastname && state.lastname !== '')) {
			return false;
		}
		return true;
	}

	const validateAge = () => {
		var m = moment(`${day.current.value}-${month.current.value}-${year.current.value}`,
				'DD-MM-YYYY')
			, now = moment();

		let currentAge = (m && m.isValid()) ? now.diff(m,
			'years',
			true) : false;

		// In the case that the age is invalid
		if (!currentAge) {
			return false;
		}

		// Check other fields if under 18
		if (currentAge >= 18) {
			return true
		} else {
			if (state['signature.firstname'] && state['signature.firstname'] !== ''
        && state['signature.lastname'] && state['signature.lastname'] !== ''
        && state['signature.legal_guardian']) {
				return true;
			}
			return false;
		}
	}

	const validateTerms = () => {
		// Handle general terms and latisse terms if applicable
		if (state['signature.signed']) {
			if (state.latisse) {
				if (state['signature.signed_latisse']) {
					return true;
				}
				return false;
			}
			return true;
		}
		return false;
	}

	// Handles enabling the continue button on form approval
	const validateForm = () => {
		let isDisabled = true
		if (validateNameAndBirthday() && validateAge() && validateTerms()) {
			isDisabled = false
		}
		setSubmitDisabled(isDisabled);
	}

	const handleBirthday = (e, name, value) => {
		let intValue = parseInt(value);
		if (name.includes('month')) {
			// auto-advance focus'ed field
			if (intValue >= 2 || value === '01') {
				// Don't let the value exceed 12, and set and single digits to double digits
				if (intValue <= 12) {
					if (value.length === 1) {
						value = '0' + value
					}
				} else {
					value = '12';
				}
				day.current.focus();
			}
		} else if (name.includes('birthday.day')) {
			// auto-advance focus'ed field
			if (intValue >= 4 || (value.length === 2 && value[0] === '0')) {
				// Don't let the value exceed 31, and set and single digits to double digits
				if (intValue <= 31) {
					if (value.length === 1) {
						value = '0' + value
					}
				} else {
					value = '31';
				}
				year.current.focus()
			}
		} else {
			// Update 2-digit year format to 4 under certain conditions
			if (value.length === 2) {
				if (intValue > 20) {
					// Since this isn't the century (19yy/20yy), we can assume the century
					value = '19' + value;
					intValue = parseInt(value);
				} else if (intValue < 19) {
					// Since this isn't the century (19yy/20yy), we can assume the century
					// Assume the patient is not over 100 so choose the 20 as the prefix
					value = '20' + value;
					intValue = parseInt(value);
				}
			}
			// Keep the years within 1900 and 2018
			if (value.length >= 4) {
				if (intValue > 2018) {
					value = '2018';
				} else if (intValue < 1900) {
					value = '1900';
				}
				year.current.blur()
			}
		}
		return value;
	}

	const checkAge = (month, day, year) => {
		var m = moment(`${day}-${month}-${year}`,
				'DD-MM-YYYY')
			, now = moment();

		let currentAge = (m && m.isValid()) ? now.diff(m,
			'years',
			true) : false;
		if (currentAge < 18) {
			return true;
		} else {
			return false;
		}
	};

	const validateResidency = (value) => {
		let tempState = {}
		// Set error if state is invalid, otherwise show next section and scroll
		if (value !== '' && !props.activeStates.includes(value)) {
			tempState = {
				stateError: `Sorry, Apostrophe is not currently offering this deal in ${value}`,
				stateIsValid: false,
				residency: value,
			};
		} else {
			tempState = {
				stateIsValid: true,
				residency: value,
				stateError: '',
				stateIsSync: props.syncStates && props.syncStates.includes(value),
			};
		}
		return tempState;
	}

	const handleChange = (e) => {
		let {
			name, value,
		} = e.target;
		let tempState = {};
		// Remove basic for state purposes
		if (name.includes('basic')) {
			name = name.slice(6);
		}
		// Handle specific validators
		if (name === 'residency') {
			tempState = validateResidency(value);
		} else if (name.includes('birthday')){
			let newValue = handleBirthday(e,
				name,
				value);
			tempState[name] = newValue;
			// Only check the age reqs when we have all the inputs (state changes are delayed, so we have to check for greater than or equal to trigger)
			if (day.current.value.length && month.current.value.length && year.current.value.length === 4) {
				tempState.underAge = checkAge(month.current.value,
					day.current.value,
					year.current.value);
			}
		} else {
			// Use the checked field for a checkbox instead of the value
			if (e.target.type === 'checkbox') {
				tempState[name] = e.target.checked;
			} else {
				tempState[name] = value
			}
		}
		// Set state to the updated state
		setState({ ...tempState })
	}

	const handleClose = () => {
		$('#main-registration').fadeIn();
		$('#react-register-info').fadeOut();
	};

	useEffect(() => {
		if (state.residency) {
			scroller.scrollTo('personal-info',
				{
					smooth: true,
					containerId: 'scroller',
				});
		}
	},
	[state.residency]);

	return (
		<Wrapper>
			<div
				id="main-registration-1"
				className="split-registration"
			>
				<PhotoContainer latisse={props.templateVersion === 'LASH'}>
					<div className="background"></div>
					<div className="info"></div>
				</PhotoContainer>
				<InfoWrapper id="scroller" sync={state.stateIsSync} stateIsValid={state.stateIsValid} className="bottom-pad react">
					<PageContent className="page-content">
						<div>
							<HeaderWrapper className="section-header">
								<h1>The road to {props.templateVersion === 'LASH' ? 'better lashes' : 'healthy skin'} starts here.</h1>
							</HeaderWrapper>
						</div>
						<SubHeader className="subheader">
              Please select your state to determine treatment options.
						</SubHeader>
					</PageContent>
					<div className="section-content inner-wrapper">
						<div className="form-group-wrapper" style={{ marginTop: '20px' }}>
							<div className="form-group">
								<div className="form-control-wrapper form-control-select input-wrapper" data-testid="state-dropdown">
									<select
										id="state"
										name="basic.residency"
										onChange={handleChange}
										value={state.residency}
									>
										<option value=""></option>
										{states.map((item, idx) => (
											<option key={idx} value={item.abbreviation}>
												{item.fullName}
											</option>
										))}
									</select>
									<label htmlFor="state" className="smaller-label-on-mobile">
                    State (current and delivery location)
									</label>
								</div>
								{state.stateError !== '' && (
									<div className="error">{state.stateError}</div>
								)}
							</div>
						</div>
					</div>
					<ScrollElement name="personal-info">
						<PersonalInfoWrapper stateIsValid={state.stateIsValid} className="section-two">
							<SubHeader PI={true} className="subheader pre-sub">

							</SubHeader>
							<SubHeader PI={true} className="subheader">
								{state.ageIneligible
									? 'Sorry - you must be at least 13 years of age to qualify for Apostrophe services.'
									: 'Please enter your legal name and date of birth. We need to know this in order to treat you.'}
							</SubHeader>
							<PageContent className="page-content">
								<div className="section-content inner-wrapper-second">
									<div id="consentForm">
										<div className="form-group-wrapper">
											<div className="form-group-inline patient-name-container">
												<FirstNameContainer className="form-group first-name-container">
													<input
														id="fname"
														name="basic.firstname"
														required
														className="form-control name-first"
														type="text"
														tabIndex="10"
														onChange={handleChange}
														autoComplete="given-name"
													/>
													<label htmlFor="fname">Legal First Name</label>
												</FirstNameContainer>
												<LastNameContainer className="form-group last-name-container">
													<input
														id="lname"
														name="basic.lastname"
														required
														className="form-control name-last"
														type="text"
														tabIndex="20"
														onChange={handleChange}
														autoComplete="family-name"
													/>
													<label htmlFor="lname">Legal Last Name</label>
												</LastNameContainer>
											</div>
											<ChosenNameContainer className="chosen-name-container">
												<div className="js-toggle-chosen-name check-btn" onClick={() => setState({
													...state,
													showChosenName: !state.showChosenName,
												})}>
													<ChosenNameCheckbox shown={state.showChosenName} data-testid="chosen-name-checkbox" />
                        My chosen name is different from my legal name
												</div>
												<ChosenName className="js-chosen-name" shown={state.showChosenName}>
													<div className="form-group">
														<input
															id="chosenName"
															name="basic.chosen_name"
															className="form-control"
															onChange={handleChange}
															type="text"
															tabIndex="25"
															value={state.chosen_name}
														/>
														<label htmlFor="chosenName">
                            Patient Chosen Name
														</label>
													</div>
												</ChosenName>
											</ChosenNameContainer>
										</div>
										<BirthdayWrapper className="form-group-wrapper input-wrapper dob-wrapper">
											<div className="form-group-birthday">
												<label htmlFor="bday-month">Date of birth</label>
												<div id="bday">
													<div className="form-group-inline js-input" id="bday-wrapper">
														<span id="bday-month-span">
															<input
																id="bday-month"
																onChange={handleChange}
																name="basic.birthday.month"
																className="form-control input-inset js-birthday-input"
																type="number"
																pattern="[0-9]*"
																maxLength="2"
																min="1"
																max="12"
																tabIndex="30"
																placeholder="MM"
																autoComplete="bday-month"
																ref={month}
																value={state['birthday.month']}
															/>
														</span>
														<span id="bday-slash-span">
															<p>/</p>
														</span>
														<span id="bday-day-span">
															<input
																id="bday-day"
																name="basic.birthday.day"
																onChange={handleChange}
																className="form-control input-inset js-birthday-input"
																type="number"
																pattern="[0-9]*"
																maxLength="2"
																min="1"
																max="31"
																tabIndex="40"
																placeholder="DD"
																autoComplete="bday-day"
																value={state['birthday.day']}
																ref={day}
															/>
														</span>
														<span id="bday-slash-span">
															<p>/</p>
														</span>
														<span id="bday-year-span">
															<input
																id="bday-year"
																onChange={handleChange}
																name="basic.birthday.year"
																className="form-control input-inset js-birthday-input"
																type="number"
																pattern="[0-9]*"
																minLength="4"
																maxLength="4"
																min="1900"
																max="2018"
																tabIndex="50"
																placeholder="YYYY"
																autoComplete="bday-year"
																ref={year}
																value={state['birthday.year']}
															/>
														</span>
													</div>
												</div>
											</div>
										</BirthdayWrapper>
										<ReferralSourceWrapper className="form-group-wrapper input-wrapper">
											<div className="form-group-hdyhau">
												<label htmlFor="referralSource">
                          How did you hear about us?
												</label>
												<div className="form-control-select">
													<select
														id="referralSource"
														name="basic.referralSource"
														onChange={handleChange}
														value={state.referralSource}
														tabIndex="55"
													>
														<option value=""></option>
														{props.referralOptions.map((item, idx) => (
															<option key={idx} value={item}>
																{item}
															</option>
														))}
														<option value="other">Other</option>
													</select>
												</div>
												{state.referralSource == 'other' &&
                          <div className="form-group-inline patient-name-container">
                          	<TextArea
                          		onChange={handleChange}
                          		id="referralSourceText"
                          		name="basic.referralSourceText"
                          		placeholder="Tell us more (if you want)"
                          		value={state.referralSourceText}
                          		tabIndex="58"
                          	/>
                          </div>
												}
											</div>
										</ReferralSourceWrapper>
									</div>
									<UnderAgeWrapper underAge={state.underAge}>
										<p className="on-under18">
                      I am the legal guardian of {state.firstname}{' '}
											{state.lastname}, and I hereby give permission to a
                      Healthcare Provider on Apostrophe to provide medical
                      services and treatment for {state.firstname}{' '}
											{state.lastname}'s medical condition.
										</p>

										<p className="js-addl-consent"></p>

										<p className="on-under18 guardian-signature">
											<small>
                        Please enter the guardian's full legal name to confirm
                        that you understand and accept these policies and terms.
											</small>
										</p>
									</UnderAgeWrapper>
									<UnderAgeWrapper className="on-under18 extra-margin-top" underAge={state.underAge}>
										<div className="controls">
											<div className="input-wrapper">
												<div className="form-group-inline">
													<div className="form-group">
														<input
															id="guardianFirst"
															type="text"
															name="signature.firstname"
															className="form-control guardian-input"
															onChange={handleChange}
															tabIndex="130"
														/>
														<label
															htmlFor="guardianFirst"
															className="smaller-label-on-mobile"
														>
                              Guardian First Name
														</label>
														<span></span>
													</div>
													<div className="form-group">
														<input
															id="guardianLast"
															type="text"
															name="signature.lastname"
															className="form-control guardian-input attr-lastname"
															onChange={handleChange}
															tabIndex="140"
														/>
														<label
															htmlFor="guardianLast"
															className="smaller-label-on-mobile"
														>
                              Guardian Last Name
														</label>
														<span></span>
													</div>
												</div>
											</div>
										</div>
									</UnderAgeWrapper>
									<div className="form-group-wrapper consent-fields">
										<UnderAgeWrapper className="on-under18 input-wrapper" style={{ marginLeft: 0 }} underAge={state.underAge}>
											<label className="consent-field">
												<input
													onChange={handleChange}
													type="checkbox"
													name="signature.legal_guardian"
													value="1"
													tabIndex="150"
												/>
												<span>
                          I am the legal guardian of {state.firstname}{' '}
													{state.lastname}.
												</span>
											</label>
										</UnderAgeWrapper>
										<TermsWrapper className="input-wrapper" style={{ marginLeft: 0 }}>
											<label className="consent-field">
												<input
													type="checkbox"
													onChange={handleChange}
													name="signature.signed"
													value="1"
													tabIndex="160"
													data-testid="terms-and-conds-checkbox"
												/>
												<span>
                          I accept Apostrophe's{' '}
													<a href="https://www.apostrophe.com/terms-of-service/" target="_blank" rel="noreferrer" >Terms of Service</a>,{' '}
													<a href="https://www.apostrophe.com/medical-notice-of-privacy-practices/" target="_blank" rel="noreferrer">Medical Notice of Privacy Practices</a>, and{' '}
													<a href="https://www.apostrophe.com/telehealth-consent-and-open-payments-notice/" target="_blank" rel="noreferrer">Telehealth consent + Open payments notice</a>.
												</span>
											</label>
										</TermsWrapper>
										<LatisseTermsWrapper className="input-wrapper" shown={state.latisse}>
											{props.cart.consultation.conditions.includes('LASH') && (
												<span className="js-addl-consent-checkbox">
													<label className="consent-field">
														<input
															onChange={handleChange}
															type="checkbox"
															data-testid="latisse-check-box"
															value="1"
															tabIndex="165"
															name="signature.signed_latisse"
														/>{' '}
														<span>
                              I understand the risks and benefits of Latisse as
                              outlined in{' '}
															<a href="https://www.apostrophe.com/informed-consent/latisse/" target="_blank" className="inline-block" rel="noreferrer">
                                Latisse Informed Consent
															</a>
														</span>
													</label>
												</span>
											)}
										</LatisseTermsWrapper>
									</div>
								</div>
							</PageContent>
							<ButtonWrapper>
								<div className="form-errors"></div>
								<button
									disabled={submitDisabled}
									className="form-submit"
									onClick={handleClose}
									type="submit"
									data-testid="submit-button"
								>
                  Continue
								</button>
							</ButtonWrapper>
						</PersonalInfoWrapper>
					</ScrollElement>
				</InfoWrapper>
			</div>
			<ScrollElement name="end" />
		</Wrapper>
	);
};

export default App;
